export const PHONE_VARIATIONS = {
  PHONE_NUMBER_INTERNATIONAL: 'phone-number-international',
  PHONE_NUMBER_USA: 'phone-number-usa',
};

export const MASK_VARIATIONS = {
  [PHONE_VARIATIONS.PHONE_NUMBER_INTERNATIONAL]: '#'.repeat(25),
  [PHONE_VARIATIONS.PHONE_NUMBER_USA]: '(999) 999-9999',
};
